export default __webpack_public_path__ + "static/small-image-richinstead-4-14ad40ad78606a093705cf9db1b2f682.png";